import { makeStyles } from '@material-ui/core/styles'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		root: {},
		textContainer: {},
		text: {
			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => `${mobileAlignment} !important`,
				},
			},
		},
		videoContainer: {},
		video: {
			marginTop: ({ videoPosition }) =>
				videoPosition === PageMetaData.ALIGNMENT.RIGHT ? theme.spacing(2) : null,
			marginBottom: ({ videoPosition }) =>
				videoPosition === PageMetaData.ALIGNMENT.LEFT ? theme.spacing(2) : null,
			[theme.breakpoints.up('md')]: {
				marginTop: theme.spacing(4),
				marginBottom: 0,
			},
		},
	}),
	{ name: 'Video1-Content' },
)

export default useStyles
